module.exports = __webpack_public_path__ + "media/images/features/5/feature-5-item-a85e4160a6219be537b7fd3ea0af4c73.png";